import { flexRender, Row } from '@tanstack/react-table'
import React from 'react'

interface ModalRowProps {
  row: Row<any>
}

export function ModalRow({ row }: ModalRowProps) {
  return (
    <div className="flex flex-col px-6">
      {row.getVisibleCells().map((cell) => {
        const header = cell.column.columnDef.header
        const hasStringHeader = typeof header === 'string' && !!header
        return (
          <React.Fragment key={cell.id}>
            {hasStringHeader && (
              <div className="relative flex max-w-full whitespace-nowrap py-2 text-secondary">
                <span className=" font-bold text-black">{header} :</span>{' '}
                <span className="w-full text-secondary">
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </span>
              </div>
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}
